import { Toaster } from "react-hot-toast";

export default function AriaToaster() {
    return (
        <Toaster
            position="bottom-right"
            reverseOrder={false}
            data-testid="aria-toaster"
            toastOptions={{
                style: {
                    overflowWrap: "break-word",
                    wordBreak: "break-all",
                    maxWidth: "400px",
                    maxHeight: "200px",
                },
            }}
        />
    );
}
